import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { InspectionAnswerResolutionRequestV2 } from './inspection-answer-resolution-request';

const path = 'inspection-answer-resolutions';

@Injectable({
  providedIn: 'root',
})
export class InspectionAnswerResolutionsHttpServiceV2 {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post(request: InspectionAnswerResolutionRequestV2): Observable<any> {
    const url = Location.joinWithSlash(this.apiBase, path + '/v2');

    return this.httpClient.post(url, request);
  }
}
